const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

export const DEMO_ROLE_IDS = new Set([3, 4]);

export const emptyPartenaireForm = {
  nom: "",
  photo_url: "",
  link_url: "",
  ordre: 1,
  is_active: true,
};

export function extractArray(data) {
  if (Array.isArray(data)) return data;

  if (data && typeof data === "object") {
    if (Array.isArray(data.rows)) return data.rows;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.partenaires)) return data.partenaires;
    if (Array.isArray(data.data)) return data.data;
  }

  return [];
}

export function normalizeText(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function isExternalURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function resolveMediaUrl(url, fallback = "/images/asso_placeholder.webp") {
  if (!url) return fallback;

  const value = String(url).trim();

  if (
    isExternalURL(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/")) {
    return `${API_BASE}${value}`;
  }

  return value;
}

export function getCurrentStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getCurrentStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function getStats(partenaires) {
  return {
    total: partenaires.length,
    active: partenaires.filter((partenaire) => partenaire.is_active !== false)
      .length,
    inactive: partenaires.filter((partenaire) => partenaire.is_active === false)
      .length,
    withLink: partenaires.filter((partenaire) =>
      String(partenaire.link_url || "").trim()
    ).length,
  };
}

export function getStatusDisplay(partenaire) {
  if (partenaire?.is_active === false) {
    return {
      label: "Inactif",
      className:
        "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
    };
  }

  return {
    label: "Actif",
    className:
      "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20",
  };
}

export function mapPartenaireToForm(partenaire = {}) {
  return {
    nom: partenaire.nom || "",
    photo_url: partenaire.photo_url || "",
    link_url: partenaire.link_url || "",
    ordre: partenaire.ordre ?? 1,
    is_active:
      typeof partenaire.is_active === "boolean"
        ? partenaire.is_active
        : true,
  };
}

export function buildPartenairePayload(formData) {
  return {
    nom: formData.nom,
    photo_url: formData.photo_url,
    link_url: formData.link_url,
    ordre: Number(formData.ordre || 1),
    is_active: Boolean(formData.is_active),
  };
}

export function safeExternalUrl(url) {
  const value = String(url || "").trim();

  if (!value) return "";

  if (/^https?:\/\//i.test(value)) return value;

  return `https://${value}`;
}